<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.keyword1"
          placeholder="请输入类别/品牌"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="searchCondition.keyword2"
          placeholder="请输入货号/名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          start-placeholder="请选择售卖时段"
          end-placeholder="请选择售卖时段"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-input
          clearable
          style="width: 100px"
          v-model.trim="searchCondition.minWxshopPrice"
          placeholder="最低零售价"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width: 100px"
          v-model.trim="searchCondition.maxWxshopPrice"
          placeholder="最高零售价"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        ref="table"
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          label="品牌"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="品类"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wxshopSpuName"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsSn"
          label="货号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="useTimeInterval"
          label="售卖时段"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.upStartTime">
              {{ scope.row.upStartTime }}至{{ scope.row.downStartTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="relOrderNum"
          label="网店售价"
        >
          <template slot-scope="scope">
            <div>
              <span class="primary" v-if="scope.row.wxshopPrice"
                >¥{{ scope.row.wxshopPrice }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberPrice"
          label="会员价"
          fit
        >
          <template slot-scope="scope">
            <div v-if="scope.row.memberPrice.length > 0">
              <div
                v-for="(v, i) in scope.row.memberPrice"
                :key="i"
                class="flex flex-center"
              >
                <div class="flex flex-wrap">
                  <div>{{ v.groupAppellation }}:</div>

                  <div class="primary" v-if="v.priceType === 'money'">
                    ¥{{ v.moneyValue }}
                  </div>
                  <div class="primary" v-else>{{ v.discountValue }}折</div>
                </div>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column label="参与活动" header-align="center" align="center">
          <template slot="header">
            <el-tooltip
              effect="dark"
              content="商品正在进行中和尚未开始的活动详情查看"
              placement="top"
            >
              <span>参与活动</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="detail(scope.row)"
                >活动详情</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 200]"
          layout="total,  prev, pager, next, jumper, sizes"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      searchCondition: {},
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async detail(row) {
      const { result } = await this.$store.dispatch("queryGoodsActiveDetail", {
        wxshopSkuId: row.wxshopSkuId
      });
      if (result.length > 0) {
        this.$router.push({
          name: "SalesActivityDetails",
          query: {
            goodsSn: row.goodsSn,
            wxshopSkuId: row.wxshopSkuId,
            id: result[0].id,
            type: result[0].auditState,
            parentId: result[0].promotionCode.split("-")[0],
            mode: "view"
          }
        });
      } else {
        this.$message({
          message: "该商品暂无活动！",
          type: "warning"
        });
      }
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.upStartTimeStr = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.downStartTimeStr = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryStoreGoodsInfoList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    setParamsCookie() {
      setCookie({
        key: "queryGoodsListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "queryGoodsListParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
// .caption {
//   position: relative;
//   padding-left: 10px;
//   color: #000;
//   margin-bottom: 20px;
//   &::before {
//     position: absolute;
//     left: 0;
//     width: 4px;
//     height: 100%;
//     background: #e50065;
//     content: "";
//     border-top-left-radius: 5px;
//     border-bottom-right-radius: 5px;
//   }
// }

// .detail-container {
//   font-size: 14px;
//   .title {
//     color: #000;
//     margin-right: 20px;
//   }
//   li {
//     margin-bottom: 20px;
//   }
//   .content {
//     > div {
//       margin-bottom: 10px;
//     }
//   }
// }

// .table-bder {
//   border: 1px solid #dddddd;
//   border-radius: 10px;
// }
// .sales-type {
//   color: #222222;
//   font-size: 15.5px;
//   font-weight: 600;
// }
</style>
